import axios from 'axios';
import { getBaseUrl } from 'shared/helpers/env.js'
/**
 * Get pre-signed URL for UB file upload
 * @param {Object} params - Upload parameters
 * @param {string} [params.scene='ai-chat'] - Upload scene
 * @param {string} [params.type='image'] - File type (image or video)
 * @returns {Promise} - Promise with pre-signed URL
 */
const BASE_URL = getBaseUrl('insite');
export const queryUploadUrl4Scene = ({ scene = 'ai-chat', type = 'image', extension } = {}) => {
  return axios({
    method: 'get',
    url: `${BASE_URL}/n/api/buyer/cs/aichat/message/preSignedSceneUpload`,
    responseType: 'json',
    params: {
      scene,
      type,
      extension
    },
  }).then(response => response.data);
};

/**
 * Upload file using pre-signed URL
 * @param {string} url - Pre-signed URL
 * @param {Blob} data - File data
 * @returns {Promise} - Promise with upload result
 */
export const queryUploadUrl4CallBack = async (url, data) => {
  try {
    return await axios({
      method: 'put',
      url,
      responseType: 'json',
      data,
      timeout: 30000,
      headers: {
        'Content-Type': data.type,
      },
    });
  } catch (error) {
    throw new Error(error);
  }
}; 